import { getAllElementsInColsInLayoutComponent, isSsrPage } from "utils"
class appNav {
  constructor(vue) {
    this.vue = vue
    this.navStatus = false
    this.mask = null
    this.navOpt = null
    this.navButton = null
    this.nav = null
    this.navButtonDom = null
  }
  async init() {
    this.toUpperZIndex() //提高当前组件及当前组件内部组件的层级
    const { navButton, nav } = await this.initShowNavControl() //初始化单击按钮显隐多级下拉的逻辑
    this.hideNav()
    this.initMask(nav)
  }
  initMask(nav) {
    nav.style.zIndex = 9999 //nav的层级需要比遮罩高
    const oldMask = document.getElementById("appNavMask")
    if (oldMask) {
      let parentDom = oldMask.parentElement
      parentDom.removeChild(oldMask)
    }
    const navBoundingOpt = nav.getBoundingClientRect()
    const _mask = document.createElement("div")
    _mask.setAttribute("id", "appNavMask")
    _mask.style.width = "414px"
    _mask.style.height = "1000px"
    _mask.style.position = "absolute"
    _mask.style.background = "rgba(0, 0, 0, 0.4)"
    _mask.style.zIndex = "999"
    _mask.style.left = "0"
    _mask.style.top = navBoundingOpt.y + navBoundingOpt.height + "px"
    _mask.style.display = "none" //初始化时隐藏
    nav.parentNode.appendChild(_mask)
    this.mask = _mask
  }
  async initShowNavControl() {
    //找到按钮和下拉菜单组件的idsStr
    const { navButton, nav } = await this.getBottomAndNavId()
    this.bindNavButtonClickEv(navButton, nav) //绑定按钮的点击触发nav显隐的事件
    if (this?.vue?.reload) {
      const _self = this
      const oldReload = this.vue.reload
      async function proxyReload() {
        await oldReload.call(_self.vue)
        await _self.deepGetEl({ nav: { ..._self.nav }, navButton: { ..._self.navButton } })
        _self.hideMask()
        _self.hideNav()
      }
      this.vue.reload = proxyReload.bind(this.vue)
    }
    return { navButton, nav }
  }
  bindNavButtonClickEv(navButton, nav) {
    if (isSsrPage() === false) return
    this.navButtonDom = navButton
    this.clickNavButtonBind = this.clickNavButton.bind(this)
    navButton.addEventListener("click", this.clickNavButtonBind, true)
  }
  clickNavButton() {
    if (this.navStatus) {
      this.hideNav()
      this.hideMask()
    } else {
      this.showNav()
      this.showMask()
    }
    this.navStatus = !this.navStatus
  }
  async hideNav() {
    let nav = await this.getNavEl(this.nav)
    if (!nav.classList.contains("active")) {
      nav.style.display = "none"
    }
  }
  async showNav() {
    const navEl = await this.getNavEl(this.nav)
    this.resetNavLeft(navEl)
    navEl.style.display = "block"
  }
  hideMask() {
    this.mask.style.display = "none"
  }
  showMask() {
    this.mask.style.display = "block"
  }
  resetNavLeft(navEl) {
    const navIds = {
      ...this.nav,
      container_id: this.vue.myid.container_id,
      rect_id: this.vue.myid.rect_id
    }
    const top = this.getAttrById(this.$store.state[this.request_prefix], navIds).top
    const x =
      navEl.parentNode.getBoundingClientRect().x - document.getElementById("container_0").getBoundingClientRect().x
    navEl.style.transform = `translate(-${x}px, ${top}${top.includes("rem") ? "" : "px"})`
  }
  async getNavEl() {
    return (await this.deepGetEl({ nav: { ...this.nav }, navButton: { ...this.navButton } })).nav
  }
  async getBottomAndNavId() {
    const allElementInLayout = getAllElementsInColsInLayoutComponent(this.vue.options.rows)
    const res = { nav: null, navButton: null }
    for (let uid in allElementInLayout) {
      if (this.navButton !== null && this.nav !== null) break //找到按钮和下拉菜单后就退出循环
      const col = allElementInLayout[uid]
      if (col.elementOptions) {
        for (let i = 0; i < col.elementOptions.length; i++) {
          if (this.navButton !== null && this.nav !== null) break
          if (col.elementOptions[i].pluginMark === "navButton") {
            this.navButton = { uid, elementInLayoutId: col.elementOptions[i].elementInLayoutId }
            res.navButton = { ...this.navButton }
          }
          if (col.elementOptions[i].pluginMark === "nav") {
            this.navOpt = col.elementOptions[i]
            this.nav = { uid, elementInLayoutId: col.elementOptions[i].elementInLayoutId }
            res.nav = { ...this.nav }
          }
        }
      }
    }

    return await this.deepGetEl(res)
  }
  isObj(val) {
    return Object.prototype.toString.call(val) === "[object Object]"
  }
  deepGetEl(res) {
    const self = this
    return new Promise((resolve, reject) => {
      deep()
      function deep(time = 0) {
        let count = 0,
          count2 = 0
        for (let k in res) {
          if (self.isObj(res[k]) === false) continue
          count++
          const ids = Object.assign({ ...self.vue.myid }, { ...res[k] })
          delete ids.pageId
          const idsStr = self.vue.$event.getIdsByStrId(ids)
          const el = document.getElementsByClassName(idsStr)[0]
          if (!!el) {
            res[k] = el
            count2++
          }
        }
        if (count !== count2) {
          if (time < 20) {
            setTimeout(() => {
              deep(time + 1)
            }, 50)
          } else reject()
        } else resolve(res)
      }
    })
  }
  toUpperZIndex() {
    document.getElementById("container_" + this.vue.myid.container_id).style.zIndex = "99"
    this.vue.$el.parentNode.style.zIndex = 9
    if (this.vue.$store.state[this.vue.request_prefix].page?.pageLayoutList) {
      this.updateNewLayoutZIndex(this.vue.$el)
    }
  }
  updateNewLayoutZIndex(el) {
    if (el.className.includes("layout-row__container")) {
      el.style.zIndex = Number(el.style.zIndex || 999) + 1
    } else if (el.parentNode && typeof el.parentNode.className === "string") {
      this.updateNewLayoutZIndex(el.parentNode)
    }
  }
  removeEventTrigger() {
    this.navButtonDom?.removeEventListener("click", this.clickNavButtonBind, true)
  }
}
export default {
  methods: {
    appNavPlugin() {
      this.appNavInstance = new appNav(this)
      this.appNavInstance.init()
    }
  },
  beforeDestroy() {
    this.appNavInstance?.removeEventTrigger()

  }
}
